import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { MainService } from 'app/resources/services/index';

type imagem = { arquivo: string, alt: string };

@Component({
  selector: 'app-vale-presente',
  templateUrl: './vale-presente.component.html'
})
export class ValePresenteComponent implements OnInit {

  public itens: Array<any> = [];

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.mainService.valePresenteService.pedidos = undefined;
    this.mainService.valePresenteService.fillPedidos();
    this.mainService.parceiroService.activate();
    this.mainService.saldoService.initialize();
    // this.avisoCovid();
  }

  public novo() {
    this.mainService.valePresenteCestaService.clean();
    this.router.navigate(['/valepresente/parceiros']);
  }

  public avisoCovid() {
    const mobile: imagem = { arquivo: '../../img/avisos/Mobile.jpg', alt: 'Comunicado Carnaval.' };
    this.mainService.aviso.alerta(mobile);
  }
}



// WEBPACK FOOTER //
// ./src/app/vale-presente/vale-presente.component.ts